import { useTranslation } from "react-i18next";
import Text from "src/components/Displays/Text";
import { Certificate1, Certificate2, Certificate3 } from "src/assets";
import { Box, CardMedia, Stack } from "@mui/material";

interface CertificateSectionProps {
  showHeadline?: boolean;
}

const CertificateSection = ({
  showHeadline = true,
}: CertificateSectionProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Stack gap={2} width="100%">
        {showHeadline && (
          <Stack
            sx={{
              maxWidth: { sm: "300px" },
              textAlign: { xs: "center", sm: "start" },
            }}
          >
            <Text
              text={t("common.CertificateSection.title")}
              sx={{
                fontWeight: 700,
                lineHeight: "21px",
              }}
            />
          </Stack>
        )}

        <Box
          sx={{
            display: { xs: "flex", sm: "none" },
            flexDirection: "column",
            gap: "16px",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "16px",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Box sx={{ height: "75px" }}>
              <CardMedia
                alt="Zertifikat1"
                component="img"
                image={Certificate1}
                sx={{ height: "100%", width: "auto", objectFit: "contain" }}
              />
            </Box>
            <Box sx={{ height: "75px" }}>
              <CardMedia
                alt="Zertifikat2"
                component="img"
                image={Certificate2}
                sx={{ height: "100%", width: "auto", objectFit: "contain" }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              height: "95px",
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <CardMedia
              alt="Zertifikat3"
              component="img"
              image={Certificate3}
              sx={{ height: "100%", width: "auto", objectFit: "contain" }}
            />
          </Box>
        </Box>

        <Box
          sx={{
            display: { xs: "none", sm: "flex" },
            flexDirection: "row",
            gap: { sm: "16px", md: "24px" },
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            ml: { md: "20px" },
          }}
        >
          <Box sx={{ height: { sm: "90px", md: "105px" } }}>
            <CardMedia
              alt="Zertifikat1"
              component="img"
              image={Certificate1}
              sx={{ height: "100%", width: "auto", objectFit: "contain" }}
            />
          </Box>
          <Box sx={{ height: { sm: "90px", md: "105px" } }}>
            <CardMedia
              alt="Zertifikat2"
              component="img"
              image={Certificate2}
              sx={{ height: "100%", width: "auto", objectFit: "contain" }}
            />
          </Box>
          <Box
            sx={{
              height: { sm: "115px", md: "135px" },
              ml: { sm: "-14px", md: "-35px" },
            }}
          >
            <CardMedia
              alt="Zertifikat3"
              component="img"
              image={Certificate3}
              sx={{ height: "100%", width: "auto", objectFit: "contain" }}
            />
          </Box>
        </Box>
      </Stack>
    </>
  );
};

export default CertificateSection;
